jQuery(document).ready(function($) {

  

  // DESIGN RESOURCES PAGE ANCHOR LINKS
    // Create a new div for the navigation (initially fully transparent)
    var $nav = $('<div>', {class: 'design-top-navigation', style: 'opacity: 0'});

    // Get only h2 elements with an id that are within section#Page--template--19828592115986__main
    var $headings = $('#design-resources h2[id]');

    // Loop over each h2 element
    $headings.each(function(){
        // Get the id and the text of the h2
        var id = $(this).attr('id');
        var text = $(this).text();

        // Create a new link element
        var $link = $('<a>', {href: '#' + id, text: text, class: 'nav-link category black'});

        // Append the link to the navigation
        $nav.append($link);
    });

    // Insert the navigation after the section#Page--template--19828592115986__main
    $('#design-resources .shopify-section--page').after($nav);

    // Wait for 1 second and then fade in the navigation
    setTimeout(function() {
        $nav.animate({opacity: 1}, 1000);
    }, 900);


  // judge.me stars badge moved next to the price
  var jdgmWidget = $('div.jdgm-widget.jdgm-preview-badge');
  var priceAndBadge = $('div.product__price-and-badge');
  priceAndBadge.append(jdgmWidget);

  // Add red slash next to page Subheading
  $('#gran-fondo-hincapie .subheading-text.category').append('<span class="red"> /</span>');
  $('#spring-series .subheading-text.category').append('<span class="red"> /</span>');
  $('#experience-domestique .subheading-text.category').append('<span class="red"> /</span>');



  // EVENT SCHEDULE READ MORE
  $(".item-desc-read-more").click(function(e){
        e.preventDefault();
        var description = $(this).prev(".item-description");
        description.toggleClass("full");
        $(this).toggleClass("opened");
    });


  // PLAN YOUR TRIP SLIDER
  var swiper = new Swiper('.plan-your-trip-swiper-container', {
    slidesPerView: 1.1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        1200: {
            slidesPerView: 3,
            spaceBetween: 30
        },
        650: {
          slidesPerView: 2.1,
          spaceBetween: 20
        }
    },
  });

  // EVENT IMAGES SLIDER
  var swiper = new Swiper('div.event-images-slider-container', {
    loop: false,
    slidesPerView: 1.25,
    centeredSlides: true,
    spaceBetween: 10,
    speed: 500,
    navigation: {
        nextEl: '.swiper-button-next.event-images-slider-next',
        prevEl: '.swiper-button-prev.event-images-slider-prev',
    },
    pagination: {
        el: '.swiper-pagination.event-images-slider-pagination',
        type: 'progressbar',
    },
    breakpoints: {
        1024: {
            slidesPerView: 1.5,
            spaceBetween: 20
        }
    },
  });


  // FAQs
  // Initialize first faq symbol to '-'
  $('.faq-item.opened .faq-symbol').text('remove');
  
  $('.faq-question').click(function(){
    var parentItem = $(this).parent();

    if(parentItem.hasClass('opened')) {
      // Close the clicked item if it is already open
      parentItem.find('.faq-answer').slideUp();
      parentItem.removeClass('opened');
      parentItem.find('.faq-symbol').text('add');
    } else {
      // Close other items
      $('.faq-item.opened').find('.faq-answer').slideUp();
      $('.faq-item.opened').find('.faq-symbol').text('add');
      $('.faq-item.opened').removeClass('opened');
      
      // Open clicked item
      parentItem.addClass('opened');
      $(this).next('.faq-answer').slideDown();
      
      // Change symbol
      $(this).find('.faq-symbol').text('remove');
    }
  });


  // GRAN FONDO RIDES SWITCHER
  $('.ride-switcher-btn').on('click', function() {
    const rideName = $(this).attr('data-ride');
    $('.ride-content-container').hide();
    $(`.ride-content-container[data-ride="${rideName}"]`).show();
  });

  // First, we mark the first ride button and container as active.
  $('.ride-switcher-btn:first').addClass('active');
  $('.ride-content-container:first').addClass('active').show();

  $('.ride-switcher-btn').on('click', function() {
    const rideName = $(this).attr('data-ride');

    // Remove the 'active' class from all buttons and containers
    $('.ride-switcher-btn').removeClass('active');
    $('.ride-content-container').removeClass('active').hide();

    // Add the 'active' class to the clicked button
    $(this).addClass('active');

    // Show the corresponding container
    $('.ride-content-container[data-ride="'+rideName+'"]').addClass('active').show();
  });



  // READ MORE
  $('.item-desc-read-more').click(function(e) {
      e.preventDefault();
      $('.ride-description-list-container').toggleClass('expanded');
      $(this).text($(this).text() === 'Read More' ? 'Read Less' : 'Read More');
  });



  // GRAN FONDO PAGE FLOATING MENU
  // Array to store the section details
    var sections = [];

    // Find all sections
    $('div[data-section-fondo]').each(function() {
        var section = {};

        // Get the id
        section.id = $(this).attr('id');

        // Get the h2 text and remove '/'
        section.title = $(this).find('h2').text().replace('/', '');

        // Get the offset position
        section.offset = $(this).offset().top;

        // Get the bottom position
        section.bottom = section.offset + $(this).outerHeight(true);

        // Add to the array
        sections.push(section);
    });

    // Create the sticky menu dynamically
    var menu = $('<div></div>')
        .attr('id', 'dynamicMenu')
        .css({
            'position': 'absolute',
            'top': sections[0].offset + 'px', // Start at the top of the first section
            'width': '200px', // Or whatever width you want
        })
        .appendTo('body'); // Append it to the body

    // Create anchor links for each section and add them to the menu
    sections.forEach(function(section) {
        $('<a></a>')
            .text(section.title)
            .attr('href', '#' + section.id)
            .css('display', 'block') // make each link a block element
            .appendTo(menu);
    });

    // Get the height of the header when scrolled
    var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--has-scrolled-header-height'));

    // Handle scroll to make the menu sticky until the last section
    $(window).scroll(function() {
        var scrollPos = $(window).scrollTop();

        // Stick menu to top when scrolling past headerHeight from the top of the first section
        if (scrollPos > (sections[0].offset - headerHeight)) {
            menu.css({
                'position': 'fixed',
                'top': 'calc(' + headerHeight + 'px + 30px)', // stick headerHeight plus 30px from top
            });
        } else {
            menu.css({
                'position': 'absolute',
                'top': sections[0].offset + 'px',
            });
        }

        // Un-stick menu when the bottom of the menu reaches the bottom of the last section
        if (scrollPos > (sections[sections.length - 1].bottom - menu.outerHeight())) {
            menu.css({
                'position': 'absolute',
                'top': (sections[sections.length - 1].bottom - menu.outerHeight()) + 'px',
            });
        }
    });

    // Handle click events on the menu links
    $('#dynamicMenu a').click(function(event) {
        // Prevent default behavior
        event.preventDefault();

        // Scroll to the appropriate section minus the header height and an extra 20px
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top - headerHeight - 20
        }, 500); // Adjust scrolling speed if needed, currently set to 1000 milliseconds
    });



  // FORM SUBMIT BUTTON: ADD CLASSES
  setTimeout(function() {
    $('button.action.submit.flat-button').addClass('btn red-btn-light');
  }, 1000);  




    // Product Variant Image Swap
    $('.swatch__input').on('change', function() {
        console.log('IMG SWAP INIT');
        // Hide all product images first
        $('.product-image').hide();

        // Show only the images of the selected color
        $(`.product-image[data-variant-color="${$(this).val()}"]`).show();
        console.log('IMG SWAP WORKING');
    });








  
  
});
